
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/video/show",
      function () {
        return require("private-next-pages/(ocelot)/video/show/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/video/show"])
      });
    }
  